import { apiClient } from '@/lib/apiClient';
import type { Page } from '@/types/api';

import type {
  Profesional,
  ProfesionalCreate,
  ProfesionalListParams,
  ProfesionalUpdate,
} from './types';

const BASE = '/profesionales';

export const profesionalesApi = {
  async create(data: ProfesionalCreate, signal?: AbortSignal): Promise<Profesional> {
    const response = await apiClient.post<Profesional>(BASE, data, { signal });
    return response.data;
  },

  async list(
    params: ProfesionalListParams & { signal?: AbortSignal } = {}
  ): Promise<Page<Profesional>> {
    const { signal, ...queryParams } = params;
    const response = await apiClient.get<Page<Profesional>>(BASE, { params: queryParams, signal });
    return response.data;
  },

  async getById(uid: string, signal?: AbortSignal): Promise<Profesional> {
    const response = await apiClient.get<Profesional>(`${BASE}/${uid}`, { signal });
    return response.data;
  },

  async update(uid: string, data: ProfesionalUpdate, signal?: AbortSignal): Promise<Profesional> {
    const response = await apiClient.patch<Profesional>(`${BASE}/${uid}`, data, { signal });
    return response.data;
  },

  async remove(uid: string, signal?: AbortSignal): Promise<void> {
    await apiClient.delete(`${BASE}/${uid}`, { signal });
  },
};
